import React from 'react';
import { Field } from 'redux-form';
import WrappedAutocomplete from '../../WrappedAutocomplete';
import builder from '../builder';


/**
 * Desktop component for selecting Cruise Line
 */
export const DesktopCruiseSelector = ({ fieldName, ...props }) => (
  <Field
    name={fieldName}
    id={fieldName}
    component={WrappedAutocomplete}
    unsafe
    {...props}
  />
);

// TODO: move to Flow types
// DesktopCruiseSelector.propTypes = {
//   fieldName: PropTypes.string
// };

export default builder(DesktopCruiseSelector);
